<template>
  <div>
    <base-multi-error-extractor v-bind="$attrs"
                                :validator="$root.$v.order.basicInformation">
      <template slot-scope="{ errorMessage }">
        <v-alert type="error">
          {{ errorMessage }}
        </v-alert>
      </template>
    </base-multi-error-extractor>
    <base-multi-error-extractor v-bind="$attrs"
                                :validator="$root.$v.order.debtors">
      <template slot-scope="{ errorMessage }">
        <v-alert type="error">
          {{ errorMessage }}
        </v-alert>
      </template>
    </base-multi-error-extractor>
    <base-multi-error-extractor v-bind="$attrs"
                                :validator="$root.$v.order.bills">
      <template slot-scope="{ errorMessage }">
        <v-alert type="error">
          {{ errorMessage }}
        </v-alert>
      </template>
    </base-multi-error-extractor>
    <base-multi-error-extractor v-bind="$attrs"
                                :validator="$root.$v.client">
      <template slot-scope="{ errorMessage }">
        <v-alert type="error">
          {{ errorMessage }}
        </v-alert>
      </template>
    </base-multi-error-extractor>
    <base-multi-error-extractor v-bind="$attrs"
                                :validator="$root.$v.moneyLaundering">
      <template slot-scope="{ errorMessage }">
        <v-alert type="error">
          {{ errorMessage }}
        </v-alert>
      </template>
    </base-multi-error-extractor>
    <base-multi-error-extractor v-bind="$attrs"
                                :validator="$root.$v.signing">
      <template slot-scope="{ errorMessage }">
        <v-alert type="error">
          {{ errorMessage }}
        </v-alert>
      </template>
    </base-multi-error-extractor>
  </div>
</template>

<script>
  import { templates } from 'vuelidate-error-extractor'

  export default {
    components: { baseMultiErrorExtractor: templates.multiErrorExtractor.baseMultiErrorExtractor },
    inheritAttrs: false
  }
</script>
